import React from "react"
import { Col, Input, Row } from "reactstrap"
import PrimaryButton from "../../../../../components/common/PrimaryButton/PrimaryButton"
import DynamicDropdown from "../../../../../components/common/SellerCommonComponents/DynamicDropdown/DynamicDropdown"

const PaymentSchedule = () => {
  const leftColData = [
    "Sales are recorded at the end of each day",
    "Payments are processed every Monday and Thursday",
    "Funds are disbursed within 2 business days after processing",
  ]

  const dropdownActions = [{ label: "1 Month" }, { label: "3 Months" }, { label: "1 Year" }]

  return (
    <section>
      <Row>
        <Col xs="12" lg="6" className="d-grid">
          <div>
            <div className="fw-semibold fs-5 my-2">Understanding Your Payment Cycle</div>
            <div className="bg-white p-2">
              <div className="border border-subtle-primary p-3">
                <ul className="my-0">
                  {leftColData.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Col>
        <Col xs="12" lg="6" className="d-grid">
          <div>
            <div className="fw-semibold fs-5 my-2">Key Dates and Deadlines</div>
            <div className="bg-white p-2">
              <div className="border border-subtle-primary p-3">
                <Row>
                  <Col>
                    <div className="fw-medium">Sales Period Ends:</div>
                  </Col>
                  <Col>
                    <div>Every Sunday and Wednesday by 23:59</div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="fw-medium">Processing Begins:</div>
                  </Col>
                  <Col>
                    <div>The following day (Monday and Thursday)</div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="fw-medium">Expected Payment Date:</div>
                  </Col>
                  <Col>
                    <div>Within 48 hours after processing</div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <div className="fw-semibold fs-5 my-2">Customize Your Payment Schedule</div>
          <div className="bg-white p-2">
            <div className="border border-subtle-primary p-3">
              <Row className="g-2">
                <Col xs="12" lg="6">
                  <Row>
                    <Col xs="12" lg="6" className="d-flex align-items-center">
                      <div>Choose Your Payment Frequency:</div>
                    </Col>
                    <Col xs="12" lg="6">
                      <DynamicDropdown options={dropdownActions} />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs="12" lg="6" className="d-flex align-items-center">
                      <div>Set Your Minimum Payment Threshold:</div>
                    </Col>
                    <Col xs="12" lg="6">
                      <div>
                        <Input placeholder="$" />
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>

      <div className="fw-semibold fs-5 my-2">Preferred Payment Method</div>
      <Row>
        <Col xs='12' lg="6">
          <div className="bg-white p-2">
            <div className="border border-subtle-primary p-3">
              <Row>
                <Col xs="12" lg="6">
                  <div className="d-flex flex-column gap-2">
                    <Row>
                      <Col xs="12" lg="6" className="d-flex align-items-center">
                        <div>HBL Bank (***1234)</div>
                      </Col>
                      <Col xs="12" lg="6">
                        <PrimaryButton name={"Update Method"} />
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </section>
  )
}

export default PaymentSchedule
